import forge from 'node-forge';
const key = forge.util.hexToBytes(process.env.NEXT_PUBLIC_ENCRYPTION_KEY);
const iv = forge.util.hexToBytes(process.env.NEXT_PUBLIC_ENCRYPTION_IV);

// Function to encrypt with AES-GCM and return ciphertext + tag (base64)
const aesGcmEncrypt = (plainText) => {
    const cipher = forge.cipher.createCipher('AES-GCM', key);
    cipher.start({ iv, tagLength: 128 });
    cipher.update(forge.util.createBuffer(plainText, 'utf8'));
    cipher.finish();

    const encrypted = cipher.output.getBytes();
    const tag = cipher.mode.tag.getBytes(); //length 16 bytes

    return forge.util.encode64(encrypted + tag); // combine ciphertext + tag
};

// Function to decrypt AES-GCM combined ciphertext+tag (base64)
const aesGcmDecrypt = (base64Data) => {
    const decoded = forge.util.decode64(base64Data);
    const encrypted = decoded.slice(0, -16); // ciphertext
    const tag = decoded.slice(-16); // last 16 bytes is the tag

    const decipher = forge.cipher.createDecipher('AES-GCM', key);
    decipher.start({ iv, tagLength: 128, tag });
    decipher.update(forge.util.createBuffer(encrypted));
    const success = decipher.finish();

    if (!success) throw new Error('Decryption failed: tag mismatch');
    return decipher.output.toString('utf8');
};

// Storing encrypted data in localStorage
export const storeEncryptedNumber = (key, mobileNumber) => {
    const encryptedMobileNumber = aesGcmEncrypt(mobileNumber);
    localStorage.setItem(key, encryptedMobileNumber);
};

// Retrieving and decrypting from localStorage
export const getDecryptedMobileNumber = (key) => {
    const encryptedMobileNumber = localStorage.getItem(key);
    if (encryptedMobileNumber) return aesGcmDecrypt(encryptedMobileNumber);
    return null;
};

// Encrypts an object and returns a URL-safe query string
export const generateEncryptedQuery = (params) => {
    const jsonString = JSON.stringify(params);
    const encrypted = aesGcmEncrypt(jsonString);
    return encodeURIComponent(encrypted);
};

// Decrypts the query string from the URL and returns an object
export const parseEncryptedQuery = (encryptedData) => {
    if (!encryptedData) return null;
    try {
        const decoded = decodeURIComponent(encryptedData);
        const decrypted = aesGcmDecrypt(decoded);
        return JSON.parse(decrypted);
    } catch (error) {
        console.error('Error decrypting query:', encryptedData);
        return null;
    }
};
